import React, {
  Suspense,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useMediaQuery } from "react-responsive";
// import Lottie from "lottie-react-web";
// const Tab = dynamic(() => import('@material-ui/core/Tab'));
// const Tabs = dynamic(() => import('@material-ui/core/Tabs'));
// const SwipeableViews = dynamic(() => import('react-swipeable-views'));
// import classes from './no_auth_classroom.module.scss'
import DescriptionContent from "../components/classroom/description-content";
// import Plyr from "plyr-react";
import Drawer from "@material-ui/core/Drawer";
import Head from "next/head";
import Link from "next/link";
import Image from "next/image";
import { logoDark, proLogoDark, SpaceCraft, HUD1 } from "../public/assets";
// import astronautLottie from "../public/assets/onboarding/astronaut.json";
import { ThemeContext, IntroContext, UserContext } from "../context";
const CancelIcon = dynamic(() => import("@material-ui/icons/Cancel"));
import dynamic from "next/dynamic";
const Dialog = dynamic(() => import("@material-ui/core/Dialog"));
const NoAuthClassroomSidebar = dynamic(
  () => import("../components/classroom/sidebar/no-auth-sidebar")
);
const Plyr = dynamic(() => import("plyr-react"), { ssr: false });
import { NextPageContext } from "next";
import { useRouter } from "next/router";
import { makeStyles } from "@material-ui/core/styles";
import { dynamicLinkPrefix } from "../helpers/constants";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import OpenAppBottomSheet from "../components/global/OpenAppBottomSheet";
import AstronautLottie from "../components/AstronautLottie";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: "6px",
    // border: '2px solid #000',
    boxShadow: "0px -4px 10px 0px #0000000D, 0px 10px 20px 0px #0000001A",
    padding: theme.spacing(2, 4, 3),
  },
}));

const getYoutubeID = (url) => {
  var regExp =
    /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;
  var match = url.match(regExp);
  return match && match[1].length === 11 ? match[1] : false;
};

function youTubeGetID(url) {
  var ID = "";
  url = url
    .replace(/(>|<)/gi, "")
    .split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
  if (url[2] !== undefined) {
    ID = url[2].split(/[^0-9a-z_\-]/i);
    ID = ID[0];
  } else {
    ID = url;
  }
  return ID;
}

const fetchLectureItem = async ({ grade, lecture_id, chapter, tab_id }) => {
  const _category = chapter.split("_")[3];
  const _subject = chapter.split("_")[4];

  let subjectPath = `${grade}_learn_${_category}`;

  if (_category !== "maths" && _category !== "mathematics") {
    subjectPath = `${grade}_learn_${_category}_${_subject}`;
  }

  if (lecture_id && chapter && tab_id) {
    return await require("../firebase-config")
      .db.collection("cms_data")
      .doc(grade)
      .collection("scope")
      .doc(`${grade}_learn`)
      .collection("category")
      .doc(`${grade}_learn_${_category}`)
      .collection("subject")
      .doc(subjectPath)
      .collection("chapter")
      .doc(chapter)
      .collection("tab")
      .doc(tab_id)
      .collection("lecture_item")
      .doc(lecture_id)
      .get()
      .then((doc) => {
        if (doc.exists) {
          let _data = doc.data();

          if (_data?.lecture_item_type === "video") {
            return {
              type: "video",
              category: _data?.category_name,
              chapter: _data?.chapter_name,
              youtube: youTubeGetID(_data?.youtube_url),
              notes: _data?.notes_link,
              item: _data,
            };
          } else if (_data?.lecture_item_type === "note") {
            return {
              type: "note",
              category: _data?.category_name,
              chapter: _data?.chapter_name,
              notes: _data?.notes_link,
              youtube: null,
              item: _data,
            };
          }
        }

        return null;
      })
      .catch((err) => console.log(err));
  } else return null;
};

const getLectureItemsForChapter = async ({ grade, chapter_id }) => {
  const _category = chapter_id.split("_")[3];
  const _subject = chapter_id.split("_")[4];

  let subjectPath = `${grade}_learn_${_category}`;

  if (_category !== "maths" && _category !== "mathematics") {
    subjectPath = `${grade}_learn_${_category}_${_subject}`;
  }

  return await require("../firebase-config")
    .db.collection("cms_data")
    .doc(grade)
    .collection("scope")
    .doc(`${grade}_learn`)
    .collection("category")
    .doc(`${grade}_learn_${_category}`)
    .collection("subject")
    .doc(subjectPath)
    .collection("chapter")
    .doc(chapter_id)
    .get()
    .then((doc) => {
      if (doc.exists) {
        let tabs = [];

        let _tabs_map = doc.data()._meta;

        _tabs_map.sort((a, b) => (a.serial_order > b.serial_order ? 1 : -1));

        for (var i = 0; i < _tabs_map?.length; i++) {
          tabs.push(_tabs_map[i]);
        }

        return [doc.data(), tabs];
      }

      return null;
    });
};

const getReferenceOfTheLectureItemById = async (
  id: string
): Promise<FirebaseFirestore.DocumentReference<FirebaseFirestore.DocumentData> | null> => {
  let items = id.split("_");
  if (items[0] !== "class") return null;
  const grade = items[0] + "_" + items[1];
  items = items.slice(2);
  let steps = [
    "scope",
    "category",
    "subject",
    "chapter",
    "tab",
    "lecture_item",
    "lecture_header_item",
  ];
  let response = await getReferenceOfTheChapterById(id);
  if (!response) return null;
  let { ref, skippable } = response;
  const length = skippable ? items.length + 1 : items.length;
  for (let i = 4; i < length; i++) {
    let itemId = grade + "_" + items.slice(0, i + 1).join("_");
    if (skippable) {
      itemId = grade + "_" + items.slice(0, i).join("_");
    }
    ref = ref.collection(steps[i]).doc(itemId);
  }

  return ref;
};

const getReferenceOfTheChapterById = async (
  id: string
): Promise<{
  ref: FirebaseFirestore.DocumentReference<FirebaseFirestore.DocumentData>;
  skippable: boolean;
} | null> => {
  let items = id.split("_");
  if (items[0] !== "class") return null;
  const grade = items[0] + "_" + items[1];
  items = items.slice(2);
  let steps = [
    "scope",
    "category",
    "subject",
    "chapter",
    "tab",
    "lecture_item",
    "lecture_header_item",
  ];
  let ref = (await import("../firebase-admin")).firebaseAdmin
    .firestore()
    .collection("cms_data")
    .doc(grade);

  let categoryRef = (await import("../firebase-admin")).firebaseAdmin
    .firestore()
    .collection("cms_data")
    .doc(grade);

  for (let i = 0; i < 2; i++) {
    const itemId = grade + "_" + items.slice(0, i + 1).join("_");
    categoryRef = categoryRef.collection(steps[i]).doc(itemId);
  }

  let skippable = false;
  const snapshot = await categoryRef.get();
  if (!snapshot.exists) return null;

  const data = snapshot.data();

  if (!data) return null;

  if (data.skippable) {
    skippable = true;
  }

  for (let i = 0; i < 4; i++) {
    let itemId = grade + "_" + items.slice(0, i + 1).join("_");
    if (skippable && i === 2) {
      itemId = grade + "_" + items.slice(0, 2).join("_");
    }
    if (skippable && i > 2) {
      itemId = grade + "_" + items.slice(0, i).join("_");
    }
    ref = ref.collection(steps[i]).doc(itemId);
  }
  return { ref, skippable };
};

// const getCookie = (cookieString: string, cookieName: string): string | null | undefined => {
// 	let arr = cookieString.split("=")
// 	let ind = arr.findIndex(c => c.includes(cookieName));
// 	if(ind < 0) return null;
// 	return arr[ind + 1];
// }

export async function getServerSideProps(context: NextPageContext) {
  // Fetch data from external API
  // const res = await fetch(`https://.../data`)
  // const data = await res.json()

  const itemId = context.query.item_id;
  console.log("context - ", context);
  // return {props: {isUser: true}}
  //
  // const cookie = context.req.headers.cookie;
  //
  // const tokenValue = getCookie(cookie, 'fsToken');
  //
  // console.log('tokenValue - ', tokenValue);

  // if(tokenValue) {
  try {
    // const headers: HeadersInit = {
    // 	'Content-Type': 'application/json',
    // 	'Authorization': JSON.stringify({ token: tokenValue })
    // };
    //
    // const protocol = context.req.headers['x-forwarded-proto'] || 'http'
    // const baseUrl = context.req ? `${protocol}://${context.req.headers.host}` : ''
    //
    // const result = await fetch(baseUrl + '/api/validate', { headers });
    // // return { props: {...result} };
    // const json = await result.json();

    if (!itemId) {
      return { props: { isUser: true, storeLink: context.query.store_link } };
    }

    const lectureItemRef = await getReferenceOfTheLectureItemById(
      itemId instanceof Array ? itemId[0] : itemId
    );
    // const chapterRef = await getReferenceOfTheChapterById(itemId);

    // if(!chapterRef) return {props: {error: "Unable to get chapter reference"}};
    if (!lectureItemRef)
      return { props: { error: "Unable to get lectureItem reference" } };

    console.log("lectureItemRef - ", lectureItemRef.path);

    // Get chapter item
    // const chapterItem = (await chapterRef.ref.get()).data();

    // Get lecture item
    const lectureItem = (await lectureItemRef.get()).data();

    // @ts-ignore
    const youtubeUrl = lectureItem.youtube_url;
    const youtubeId = getYoutubeID(youtubeUrl);

    // Pass data to the page via props
    return {
      props: {
        chapterItem: {},
        lectureItem,
        youtubeId,
        storeLink: context.query.store_link,
        context: "json",
      },
    };
  } catch (e) {
    console.log("e - ", e);
    // let exceptions fail silently
    // could be invalid token, just let client-side deal with that
  }
  // }
  // return {
  // 	redirect: {
  // 		permanent: false,
  // 		destination: '/'
  // 	}
  // }
}

const CheckIconImage = (
  <svg width="191.667" height="191.667" xmlns="http://www.w3.org/2000/svg">
    <metadata id="metadata870">image/svg+xml</metadata>

    <g>
      <title>Layer 1</title>
      <path
        fill="#cccccc"
        strokeWidth="0.66292"
        id="path833"
        d="m95.833,32.3036c-35.03,0 -63.52957,28.49891 -63.52957,63.52957c0,35.03066 28.49957,63.53023 63.52957,63.53023c35.03,0 63.52957,-28.49957 63.52957,-63.53023c0,-35.03066 -28.49891,-63.52957 -63.52957,-63.52957zm36.4798,52.79889l-39.9124,39.9124c-1.69707,1.69707 -3.95299,2.63112 -6.35276,2.63112c-2.39977,0 -4.65568,-0.93405 -6.35276,-2.63112l-20.34168,-20.34169c-1.69708,-1.69707 -2.63179,-3.95299 -2.63179,-6.35276c0,-2.40043 0.93471,-4.65634 2.63179,-6.35342c1.69641,-1.69707 3.95232,-2.63179 6.35276,-2.63179c2.39977,0 4.65634,0.93472 6.35276,2.63245l13.98826,13.98761l33.55898,-33.55898c1.69708,-1.69707 3.95299,-2.63113 6.35276,-2.63113c2.39977,0 4.65568,0.93406 6.35276,2.63113c3.50419,3.50419 3.50419,9.20331 0.00089,12.70618l0.00043,0z"
      />
      <g id="g835" />
      <g id="g837" />
      <g id="g839" />
      <g id="g841" />
      <g id="g843" />
      <g id="g845" />
      <g id="g847" />
      <g id="g849" />
      <g id="g851" />
      <g id="g853" />
      <g id="g855" />
      <g id="g857" />
      <g id="g859" />
      <g id="g861" />
      <g id="g863" />
    </g>
  </svg>
);

function ClassroomPlayer({ videoId }) {
  const plyrRef = useRef(null);
  const video_id = useMemo(() => videoId, [videoId]);

  useEffect(() => {
    console.log("plyrRef.current - ", plyrRef.current);
    if (plyrRef.current.plyr) {
      plyrRef.current.plyr.autoplay = true;
    }
  });

  return (
    <div className={"classroom-player-wrapper"}>
      <Plyr
        ref={plyrRef}
        source={{
          type: "video",
          // @ts-ignore
          sources: [{ src: video_id, provider: "youtube" }],
        }}
        autoPlay={true}
      />
    </div>
  );
}

export function ClassRoomState({ setUser }) {
  const [openSignupModal, setOpenSignupModal] =
    useContext(IntroContext).openSignupModal;
  const isSmallScreen = useMediaQuery({ query: "(max-width: 500px)" });
  const [trialType, setTrialType] = useContext(IntroContext).trialType;
  const [isDark] = useContext(ThemeContext).theme;
  const router = useRouter();
  const [isSliderOpen, setIsSliderOpen] = useContext(UserContext).isSliderOpen;
  const [, setOpenGuestBottomDrawer] =
    useContext(UserContext).openGuestBottomDrawer;

  useEffect(() => {
    if (openSignupModal) {
      isSmallScreen
        ? setOpenGuestBottomDrawer("classroom")
        : setOpenSignupModal(() => {
            setIsSliderOpen(true);
            return false;
          });
    }
  }, [isSmallScreen, openSignupModal]);

  return (
    <>
      {/*<Suspense fallback={<></>}>*/}
      {/*	<OnBoardingFlow*/}
      {/*		isOpen={isSliderOpen}*/}
      {/*		setUser={setUser}*/}
      {/*		handleClose={() => setIsSliderOpen(!isSliderOpen)}*/}
      {/*	/>*/}
      {/*</Suspense>*/}
      <Dialog
        onClose={() => {
          setOpenSignupModal(false);
        }}
        aria-labelledby="welcome"
        // open={openFreeTrial && trialType}
        open={openSignupModal}
        className={
          isDark ? "welcome-dialog-wrapper2 dark" : "welcome-dialog-wrapper2"
        }
      >
        <div className="welcome-dialog">
          <div className="stars__background">
            <div className="stars" />
            <div className="twinkling" />
          </div>
          <CancelIcon
            className="close-welcome-dialog"
            onClick={() => {
              setTrialType(null);
              setOpenSignupModal(false);
            }}
          />
          <Image
            height={100}
            width={100}
            className="logo"
            src={proLogoDark}
            alt="logo"
            draggable={false}
          />
          <div className="astronaut">
            <AstronautLottie />
          </div>

          {/*<Image height={100} width={100}*/}
          {/*       className="welcome-spacecraft"*/}
          {/*       src={SpaceCraft}*/}
          {/*       alt="spacecraft"*/}
          {/*       draggable={false}*/}
          {/*/>*/}
          <div className="welcome-text">
            <Image
              height={100}
              width={100}
              className="welcome-background"
              src={HUD1}
              alt="hud"
              draggable={false}
            />
            <h1>
              {trialType === "referred" ? "CONGRATULATIONS" : "WELCOME OFFER"}
            </h1>

            <h2>
              Enjoy {trialType === "referred" ? "30" : "7"} days of PuStack Pro
              for FREE
            </h2>

            <button
              className="call-to-action-welcome"
              onClick={() => {
                isSmallScreen
                  ? setOpenGuestBottomDrawer("classroom")
                  : setOpenSignupModal(() => {
                      setIsSliderOpen(true);
                      return false;
                    });
              }}
            >
              Sign Up
            </button>
          </div>
        </div>
      </Dialog>
      <OpenAppBottomSheet />
    </>
  );
}

export function ClassroomNavbar({ activeItem }) {
  const [, setIsSliderOpen] = useContext(IntroContext).signInSliderOpen;
  const isSmallScreen = useMediaQuery({ query: "(max-width: 500px)" });
  const [, setBoardingFlowOpen] = useContext(UserContext).isSliderOpen;
  const router = useRouter();

  return (
    <div className="classroom__navbar">
      <Link href="/">
        <div className="classroom__logo">
          <Image
            height={100}
            width={100}
            className="header__leftImage"
            src={logoDark}
            alt="PuStack"
            draggable={false}
          />
        </div>
      </Link>
      <div className="separator">|</div>
      <div className="classroom__chapter__name">
        {activeItem?.lecture_header_item_name ?? activeItem?.lecture_item_name}
      </div>{" "}
      <div
        className={"classroom__progress no_user"}
        style={{ display: "flex" }}
      >
        {!isSmallScreen && (
          <span
            onClick={() => {
              // router.query.step = "login"
              // router.push(router);
              // isSmallScreen ? setBoardingFlowOpen('sign-in') : setIsSliderOpen(true);
              setBoardingFlowOpen("sign-in");
              // navigator && navigator.vibrate && navigator.vibrate(5);
            }}
            className="animated-gradient-text-full-access-for-free"
          >
            Full Access for FREE
          </span>
        )}
        <span className="nav__links">
          {/*<a href="https://tutor.pustack.com">Tutor Login</a>*/}
          {isSmallScreen && (
            <div className="gradient-button">
              <button
                onClick={() => {
                  // router.query.step = "login"
                  // router.push(router);
                  // isSmallScreen ? setBoardingFlowOpen('sign-in') : setIsSliderOpen(true);
                  setBoardingFlowOpen("sign-in");
                  // navigator && navigator.vibrate && navigator.vibrate(5);
                }}
              >
                <span>Sign Up</span>
              </button>
            </div>
          )}
          {!isSmallScreen && (
            <span
              className="nav__link signup__btn"
              onClick={() => {
                // router.query.step = "login"
                // router.push(router);
                // isSmallScreen ? setBoardingFlowOpen('sign-in') : setIsSliderOpen(true);
                setBoardingFlowOpen("sign-in");
                // navigator && navigator.vibrate && navigator.vibrate(5);
              }}
            >
              Sign Up
            </span>
          )}
        </span>
      </div>
    </div>
  );
}

export default function NoAuthClassRoomPage({
  lectureItem,
  youtubeId,
  storeLink,
  setUser,
  ...props
}) {
  // const [isSliderOpen, setIsSliderOpen] = useState(false);
  const isTabletScreen = useMediaQuery({ query: "(max-width: 980px)" });
  const isMobileScreen = useMediaQuery({ query: "(max-width: 500px)" });
  const [classroomChapter, setClassroomChapter] = useState(null);
  const [classroomTabsData, setClassroomTabsData] = useState(null);
  const [videoId, setVideoId] = useState(null);
  const router = useRouter();
  const [activeItem, setActiveItem] = useState(null);
  const classes = useStyles();
  const [showPromptForStoreLink, setShowPromptForStoreLink] = useState(false);
  // const [openSignUpModal, setOpenSignUpModal] = useState(false);

  // const tags = lectureItem.generated_tags.reduce((acc, curr, ind) => {
  // 	acc += curr;
  //
  // 	if(ind !== lectureItem.generated_tags.length - 1) acc += ', '
  //
  // 	return acc
  // }, '');

  useEffect(() => {
    console.log("strokeLink - ", storeLink);
    if (storeLink) {
      setShowPromptForStoreLink(true);
    }
  }, [storeLink]);

  useEffect(() => {
    if (!router.query.subject || !router.query.chapter) return;
    async function run() {
      setClassroomChapter(router.query.chapter);

      const grade = router.query.chapter.split("_").slice(0, 2).join("_");

      let [_data, _tabs] = await getLectureItemsForChapter({
        grade,
        chapter_id: router.query.chapter,
      });

      setClassroomTabsData(_tabs);

      const lectureItem = _tabs[0].lecture_items.find(
        (c) => c.serial_order === 1
      );

      let lecture_item_data = await fetchLectureItem({
        grade,
        lecture_id: lectureItem.lecture_item_id,
        chapter: router.query.chapter,
        tab_id: _tabs[0].tab_id,
      });

      setVideoId(lecture_item_data?.youtube);

      setActiveItem(lecture_item_data?.item);
    }

    run();
  }, [router.query]);

  return (
    <>
      <div className="classroom__screen__wrapper">
        <Head>
          <title>{activeItem?.chapter_name + " | PuStack"}</title>
          <meta
            name="keywords"
            content={`${activeItem?.chapter_name}, pustack, classroom, lectures`}
          />
          <meta name="description" content={activeItem?.image_content} />
        </Head>
        {/*{Navbar goes here...}*/}
        <ClassroomNavbar activeItem={activeItem} />
        <div className="classroom__screen is_guest no_auth">
          <div className="classroom__content">
            {/*<ClassroomPlayer video_id={youtubeId} />*/}
            {/*Player goes here...*/}
            <ClassroomPlayer videoId={videoId} />
            <div className="classroom__breadcrumb">
              <h1>
                {activeItem?.lecture_header_item_name
                  ? activeItem?.lecture_header_item_name +
                    " | " +
                    activeItem?.lecture_item_name
                  : activeItem?.lecture_item_name}{" "}
                | {activeItem?.chapter_name}
              </h1>
              {/*<p>{chapterItem?.description ?? ''}</p>*/}
            </div>
            {!isTabletScreen && activeItem?.image_content && (
              <DescriptionContent content={activeItem?.image_content} />
            )}
          </div>
          <NoAuthClassroomSidebar
            classroomTabsData={classroomTabsData}
            chapterID={classroomChapter}
            setVideoSeeking={() => {}}
            videoSeeking={false}
            currentItem={activeItem}
            content={activeItem?.image_content}
          />
        </div>
        <ClassRoomState setUser={setUser} />
      </div>
    </>
  );
}
